import { Text } from "@mantine/core";

const MantineText = (props: any) => {
    const { fw, name, className, size, tt, ta, c, td, onClick, py, children, key,style } = props;
    return (
        <Text fw={fw}
            className={className}
            tt={tt}
            size={size}
            c={c}
            ta={ta}
            onClick={onClick}
            td={td}
            py={py}
            key={key}
            style={style}
        >
            {name || children}
        </Text>
    );
};

export default MantineText;